import { useState } from "react";
import { useMutation } from "react-query";
import { t } from "@/i18n-js/instance";
import { WorkflowsMomentumModal } from "@/react/components/WorkflowsMomentumModal";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { isCommunityAdmin } from "@/react/helpers/communityMemberHelpers";
import { ModalManager } from "@circle-react/components/Layout/ModalManagerProvider";
import { reactQueryPost } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useToast } from "@circle-react-uikit/ToastV2";

const COMMENT_FLAGGED_CONTENTABLE_TYPE = "Comment";

export const useReportHandler = ({ comment }) => {
  const { id } = comment;
  const { success, error } = useToast();
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const { currentCommunityMember } = usePunditUserContext();

  const openReportModal = () => setIsReportModalOpen(true);
  const closeReportModal = () => setIsReportModalOpen(false);

  const { mutate: submitReport } = useMutation(
    formData =>
      reactQueryPost(internalApi.flaggedContent.create(), {
        flagged_content: {
          ...formData,
          flagged_contentable_id: id,
          flagged_contentable_type: COMMENT_FLAGGED_CONTENTABLE_TYPE,
        },
      }),
    {
      onSuccess: () => {
        success(t("comments.report.alerts.success"), {
          duration: "short",
          shouldUseProgress: false,
        });
        closeReportModal();

        if (isCommunityAdmin(currentCommunityMember)) {
          void ModalManager.show(WorkflowsMomentumModal, {
            templateKey: "ai_moderate_new_comments",
          });
        }
      },
      onError: () => {
        error(t("comments.report.alerts.failure"));
      },
    },
  );

  return {
    isReportModalOpen,
    openReportModal,
    closeReportModal,
    submitReport,
  };
};
